// Action Cable provides the framework to deal with WebSockets in Rails.
import { createConsumer } from "@rails/actioncable";

export default createConsumer();
